import { render, staticRenderFns } from "./course-agreement.vue?vue&type=template&id=2551b55e&scoped=true&"
import script from "./course-agreement.vue?vue&type=script&lang=js&"
export * from "./course-agreement.vue?vue&type=script&lang=js&"
import style0 from "./course-agreement.vue?vue&type=style&index=0&id=2551b55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551b55e",
  null
  
)

export default component.exports